@if (isApplicationLoading()) {
  <app-page-loading />
} @else {
  <div
    appAddClassModifier
    class="app"
    [class.app_is-fixed]="isSideNavBarVisible()"
    [class.app_is-sidebar-collapsed]="isSideBarCollapsed()"
  >
    <div class="app__container">
      @if (isAdminAuthenticationValid()) {
        <div class="app__header">
          <app-header />
        </div>
      }
      <div class="app__content-container">
        @if (isAdminAuthenticationValid()) {
          <div
            class="app__sidebar"
            [class.app__sidebar_is-visible]="isSideNavBarVisible()"
          >
            <app-sidebar />
          </div>
        }
        <div
          class="app__content"
          [class.app__content_is-full-width]="!isAdminAuthenticationValid()"
        >
          @if (isScreenPositionNotOnTop) {
            <div
              data-auto-id="moveToTop"
              class="app__move-to-top"
              role="button"
              aria-label="Move to top"
              title="Move to top"
              (click)="moveToTop()"
            ></div>
          }
          <router-outlet />
        </div>
      </div>
    </div>

    @if (shouldShowObjectDebugger) {
      <div
        class="app__object-debugger"
        [class.app__object-debugger_is-visible]="isObjectDebuggerVisible()"
      >
        @if (isObjectDebuggerVisible()) {
          <blu-object-debugger
            (closed)="closeObjectDebugger()"
            [isDark]="isDarkMode"
          />
        } @else {
          <div
            data-auto-id="showObjectDebugger"
            class="app__object-debugger-toggle"
            (click)="showObjectDebugger()"
          >
            <img
              class="app__object-debugger-toggle-image"
              src="assets/icons/object-debugger/bug.svg"
              alt="bug icon"
            />
          </div>
        }
      </div>
    }
  </div>
}

@if (isEditPasswordModalOpen()) {
  <app-x-modal
    modalTitle="Change Password"
    (modalClosed)="closeEditPasswordModal()"
  >
    <app-edit-password (passwordChanged)="closeEditPasswordModal()" />
  </app-x-modal>
}
